import styled from 'styled-components'

export const SContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

export const SLabel = styled.label<{ size: 'sm' | 'md' | 'lg' }>`
    position: relative;
    display: inline-block;
    width: 48px;
    min-width: 48px;
    height: 30px;
    border-radius: 34px;
    background-color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
    border: 1px solid #a1a1a1;
    padding: 4px;
    margin-bottom: unset;
    transition: all 0.2s ease-in;
    transform: ${({ size }) => {
        if (size === 'sm') return 'scale(0.6)'
        if (size === 'md') return 'scale(0.8)'
        return 'scale(1)'
    }};

    &.toggled {
        background-color: ${({ theme }) => theme.font.successColor};
        & > #slider:before {
            -webkit-transform: translateX(18px);
            -ms-transform: translateX(18px);
            transform: translateX(18px);
        }
    }

    &.disabled {
        opacity: 0.5;
    }

    &:before {
        border-radius: 50%;
    }
    @media (max-width: 600px) {
        font-size: 14px;
    }
`

export const Slider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 100%;

    &:before {
        position: absolute;
        content: '';
        height: 22px;
        width: 22px;
        left: 3px;
        top: 3px;
        background-color: white;
        border: 1px solid #a1a1a1;
        border-radius: 100%;
        transition: all 0.2s ease-in;
    }

    &.disabled {
        cursor: not-allowed;
    }
`
